
export interface RegisterCard200Response {
  billingKey?: string;
  cardName?: string;
  message?: string;
  success: boolean;
}
